export const transformPhoneNumber = (phone: string | undefined) =>
  phone ? `+7${phone.replace(/[()_ -]/g, "")}` : undefined;
